export const SUP_ONLINE_TOOLS_CELL_PREPARATION_LOADER = {
  desktop: `
  <div class="cui-grid cui-container">
  <div class="cui-skeleton-paragraph -spacing--top-64 -spacing--bottom-40">
    <div class="cui-skeleton-paragraph__content" style="width: 170px">
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <div class="cui-skeleton-heading -size--large -resolution--desktop -spacing--bottom-40">
    <div class="cui-skeleton-heading__content">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>

  <div class="cui-row">
    <div class="cui-col-md-3 cui-col-sm-4">
      <div class="cui-skeleton__item -spacing--bottom-24" style="width: 60%; height: 28px;"></div>
      <div class="cui-skeleton-paragraph__content" style="width: 100%;">
        <div class="cui-skeleton__item -spacing--bottom-16" style="height: 72px;"></div>
        <div class="cui-skeleton__item -spacing--bottom-16" style="height: 72px;"></div>
        <div class="cui-skeleton__item -spacing--bottom-16" style="height: 72px;"></div>
        <div class="cui-skeleton__item -spacing--bottom-16" style="height: 72px;"></div>
      </div>
      <div class="cui-skeleton-button -size--large" style="display: flex;">
        <div class="cui-skeleton-button__content" style="width: 120px;">
          <div class="cui-skeleton__item cui-skeleton-button__button"></div>
        </div>
      </div>
    </div>
    <div class="cui-col-md-3 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item -spacing--bottom-24" style="width: 60%; height: 28px;"></div>
        <div class="cui-skeleton__item" style="width: 100%; height: 300px;"></div>
      </div>
    </div>
  </div>

  <!-- Additional spacing -->
  <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 120px;"></div>
  </div>
  `
};
